import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoOs: CultureInfo = {
  name: 'os',
  displayName: 'ирон',
  iso3LanguageCode: 'oss',
  iso2LanguageCode: 'os',
  ietfLanguageTag: 'os',
  parent: null
};
